import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import { G_MAPS_Z_INDEX } from '@/data/constants/common';
import { SxProps, Theme } from '@mui/material/styles';

export const sidebarSX: Record<string, SxProps<Theme>> = {
	appBar: {
		top: 'auto',
		bottom: '60px',
		height: (theme) => theme.spacing(8),
		lineHeight: (theme) => theme.spacing(6),
		p: '10px',
		zIndex: G_MAPS_Z_INDEX, // it was 1200 but google map autocomplete zIndex is 1000
		justifyContent: 'center',
	},
	appBarStack: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	appBarBtnAction: { display: 'flex', gap: 0.75, p: '10px', height: '42px' },
	mobileDrawerPaper: {
		width: '90% !important',
		padding: '0px !important',
		maxWidth: '360px !important',
		minWidth: '288px !important',
		'& > div': {
			height: 'calc(100% - 60px)',
		},
	},
	skeletonContainer: {
		width: '100%',
		maxWidth: '100%',
		[`@media (min-width: ${DESKTOP_MIN_WIDTH - 1}px)`]: { maxWidth: '250px', width: '250px' },
	},
};

export const sidebarAppBarContainerSX: SxProps<Theme> = {
	top: 'auto',
	bottom: 0,
	height: (theme) => theme.spacing(6),
	lineHeight: (theme) => theme.spacing(6),
	py: 0,
	px: 2,
	boxShadow: 2,
	zIndex: G_MAPS_Z_INDEX, // it was 1200 but google map autocomplete zIndex is 1000
};
